<template>
    <Tooltip maxWidth="800" :text="$t(text, { date: date })">
        <template v-slot:item>
            <span class="ml-2"><v-icon class="pointer info--text">info</v-icon></span>
        </template>
    </Tooltip>
</template>

<script>
import Tooltip from '../../../ui/Tooltip';
export default {
    props: ['date', 'text'],
    components: { Tooltip },
    computed: {
        tooltipText() {
            return this.$t(
                'Здесь отображен предварительный просмотр данных из файла с учётом информации из биллинговой системы ALSECO Heat. Данные актуальны по состоянию на дату загрузки:'
            );
        }
    }
};
</script>

<style></style>
